export default __webpack_public_path__ + "static/b2bBannerBg-de111cc7397e5c5689bc49d148cf4a48.png";